import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BankAccount } from '../../types/bankAccount';

export interface FinancialState {
  bankAccount: BankAccount | null;
}
const initialState: FinancialState = {
  bankAccount: null,
};

const financialSlice = createSlice({
  name: 'financial',
  initialState,
  reducers: {
    setBankAccount(
      state,
      action: PayloadAction<{ communityId: number; bankAccount: BankAccount }>,
    ): void {
      state.bankAccount = action.payload.bankAccount;
    },
  },
});

export const { setBankAccount } = financialSlice.actions;
const financialReducer = financialSlice.reducer;
export default financialReducer;
